import React, { lazy, Suspense, memo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import TxtFileService from "services/TxtFileService";
// import fetch from "auth/FetchInterceptor";
import { saveAdminSettings } from "store/slices/authSlice";
import { RefreshProvider } from "./RefreshContext";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  useBodyClass(`dir-${direction}`);

  const themeConfig =
    currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAdminSettings = async () => {
      try {
        // setLoading(true)
        const { data } = await TxtFileService.getTxtFileLinks();

        if (data.generalTxt) {
          //   const settings = await fetch({
          //     url: data.generalTxt,
          //     method: "get",
          //   });
          const [generalData] = await Promise.all([
            fetch(data.generalTxt).then((res) => res.json()),
          ]);
          if (generalData) {
            dispatch(
              saveAdminSettings(generalData?.adminSettings?.[0] || null)
              //   saveAdminSettings({
              //     adminSettings: generalData?.adminSettings?.[0] || null,
              //   })
            );
          }
          console.log("666 settings", generalData);
        }
      } catch (e) {
        console.error(e);
      } finally {
        // setLoading(false)
      }
    };
    // fetchAdminSettings();
  }, []);

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <RefreshProvider>
          <Layout>
            <Routes />
          </Layout>
        </RefreshProvider>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
